import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import Layout from '@/components/Layout';
import Dashboard from '@/pages/Dashboard';
import Explorer from '@/pages/Explorer';
import Submit from '@/pages/Submit';
import RequestDataModal from '@/components/RequestDataModal';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import { adminToken } from '@/lib/api';

function RequireAdmin({children}) {
 if(!adminToken.get())return <Navigate to="/admin/login" replace/>;
 return children;
}
function AppRoutes() {
 const location=useLocation(), navigate=useNavigate();
 const requesting=location.pathname==='/request-data';
 const background=requesting ? location.state?.backgroundLocation : null;
 return <>
  <Layout>
   <Routes location={requesting ? background || '/' : location}>
    <Route path="/" element={<Dashboard/>}/>
    <Route path="/explore" element={<Explorer/>}/>
    <Route path="/submit" element={<Submit/>}/>
    <Route path="/admin/login" element={<AdminLogin/>}/>
    <Route path="/admin" element={<RequireAdmin><AdminDashboard/></RequireAdmin>}/>
    <Route path="*" element={<Navigate to="/" replace/>}/>
   </Routes>
  </Layout>
  {requesting && <RequestDataModal onClose={()=>background ? navigate(-1) : navigate('/',{replace:true})}/>}
 </>;
}
export default function App() {
 return <div className="App"><BrowserRouter><AppRoutes/></BrowserRouter><Toaster position="bottom-right" richColors/></div>;
}
